/* =========================================================
   DearRoot — Product page logic
   bundle selector • subscribe & save • gallery • add-to-cart
   ========================================================= */
(function () {
  'use strict';
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  // Format in the buyer's active (presentment) currency. Shopify converts the
  // amounts in `data-*`; hardcoding "$" makes AED/EUR/etc. render the wrong symbol.
  const _cfg = window.DR_CFG || {};
  let _nf = null;
  try {
    _nf = new Intl.NumberFormat(_cfg.locale || 'en', {
      style: 'currency', currency: _cfg.currency || 'USD',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    });
  } catch (e) { _nf = null; }
  const money = n => _nf ? _nf.format(n) : '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  const cents = c => money((+c || 0) / 100);

  let mode = 'sub';              // 'sub' | 'once'  (default: subscribe & save)
  let selected = null;

  const bundles = $$('.bundle');
  if (!bundles.length) return;

  // Each bundle is bound to a real Shopify variant (+ optional subscription selling
  // plan). All prices come from Shopify in cents via the data-* attributes.
  const data = b => ({
    el: b,
    variant: b.dataset.variant,
    plan: b.dataset.plan || null,
    months: +b.dataset.months || 1,
    once: +b.dataset.once || 0,                              // one-time price (cents)
    sub: b.dataset.sub ? +b.dataset.sub : null,              // subscription price (cents)
    compare: b.dataset.compare ? +b.dataset.compare : null   // compare-at (cents)
  });

  const hasSub = d => mode === 'sub' && d.sub != null && d.plan;
  function priceFor(d) { return hasSub(d) ? d.sub : d.once; }       // cents
  function wasFor(d)   { return hasSub(d) ? d.once : d.compare; }   // cents | null

  function paint() {
    bundles.forEach(b => {
      const d = data(b);
      const now = priceFor(d);          // cents
      const was = wasFor(d);            // cents | null
      b.querySelector('.b-price').textContent = cents(now);
      const wasEl = b.querySelector('.b-was');
      const saveEl = b.querySelector('.b-save');
      if (was && was > now) {
        if (wasEl) { wasEl.textContent = cents(was); wasEl.style.display = ''; }
        if (saveEl) { saveEl.textContent = 'SAVE ' + cents(was - now); saveEl.style.display = ''; }
      } else {
        if (wasEl) wasEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
      const sup = b.querySelector('.b-supply');
      if (sup) sup.textContent = cents(Math.round(now / d.months)) + '/mo';
    });
    paintATC();
  }

  function paintATC() {
    if (!selected) return;
    const d = data(selected);
    const now = priceFor(d);      // cents
    const was = wasFor(d);        // cents | null
    const showWas = was && was > now;
    // main buy block
    const nowEl = $('#atcNow'), wasEl = $('#atcWas'), offEl = $('#atcOff');
    if (nowEl) nowEl.textContent = cents(now);
    if (wasEl) { if (showWas) { wasEl.textContent = cents(was); wasEl.style.display = ''; } else wasEl.style.display = 'none'; }
    if (offEl) { if (showWas) { offEl.textContent = Math.round((1 - now / was) * 100) + '% OFF'; offEl.style.display = ''; } else offEl.style.display = 'none'; }
    const lbl = $('#atcLabel');
    if (lbl) lbl.textContent = (hasSub(d) ? 'Subscribe — ' : 'Add to Cart — ') + cents(now);
    // sticky bar
    const sNow = $('#stickyNow'), sWas = $('#stickyWas');
    if (sNow) sNow.textContent = cents(now);
    if (sWas) { if (showWas) { sWas.textContent = cents(was); sWas.style.display = ''; } else sWas.style.display = 'none'; }
  }

  function selectBundle(b) {
    selected = b;
    bundles.forEach(x => x.setAttribute('aria-checked', x === b ? 'true' : 'false'));
    paintATC();
  }

  bundles.forEach(b => {
    b.addEventListener('click', () => selectBundle(b));
    b.addEventListener('keydown', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); selectBundle(b); } });
  });

  // mode toggle
  function applyMode() {
    const sn = $('#subNote');
    if (sn) sn.style.display = mode === 'sub' ? 'flex' : 'none';
    $$('.incl-sub').forEach(el => { el.style.display = mode === 'sub' ? '' : 'none'; });
  }
  $$('.buy-mode button').forEach(btn => {
    btn.addEventListener('click', () => {
      mode = btn.dataset.mode;
      $$('.buy-mode button').forEach(x => x.setAttribute('aria-pressed', x === btn ? 'true' : 'false'));
      applyMode();
      paint();
    });
  });

  // add to cart
  function doAdd(btn) {
    if (!selected) return;
    const d = data(selected);
    if (!d.variant || !(window.DR && DR.cartAdd)) return;
    const item = { id: d.variant, quantity: 1 };
    if (hasSub(d)) item.selling_plan = d.plan;     // real subscription selling plan
    if (btn) btn.classList.add('is-loading');
    Promise.resolve(DR.cartAdd([item])).finally(() => { if (btn) btn.classList.remove('is-loading'); });
  }
  $$('[data-add]').forEach(b => b.addEventListener('click', () => doAdd(b)));

  // The sticky bar CTA scrolls up to the buy box (so the shopper picks a bundle + plan) instead of
  // adding blindly. It carries no [data-add], so it's never wired to doAdd above.
  const stickyBtn = document.querySelector('#stickyBuy');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const anchor = document.querySelector('#buyAnchor');
      if (!anchor) return;
      const y = anchor.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  /* ---------- Gallery (scroll-snap slider) ---------- */
  const track = $('#galTrack');
  const thumbs = $$('.gal-thumb');
  let galIdx = 0;

  if (track && thumbs.length) {
    track.innerHTML = thumbs.map((t, i) => {
      const src = t.dataset.full || (t.querySelector('img') ? t.querySelector('img').src : '');
      const fit = t.dataset.fit || 'cover';
      const srcset = t.dataset.srcset || '';
      const sizes = t.dataset.sizes || '';
      const attrs = [
        `src="${src}"`,
        srcset ? `srcset="${srcset}"` : '',
        sizes ? `sizes="${sizes}"` : '',
        'alt=""',
        i === 0 ? 'fetchpriority="high"' : 'loading="lazy"',
        'decoding="async"'
      ].filter(Boolean).join(' ');
      return `<div class="gal-slide${fit === 'contain' ? ' contain' : ''}"><img ${attrs}></div>`;
    }).join('');
  }
  const slides = track ? $$('.gal-slide', track) : [];

  function setActive(i) {
    galIdx = (i + thumbs.length) % thumbs.length;
    thumbs.forEach((x, k) => x.classList.toggle('active', k === galIdx));
    // keep the active thumbnail visible within its (mobile) scroll strip
    const active = thumbs[galIdx];
    const strip = active && active.parentElement;
    if (!active || !strip) return;
    // horizontal scroller (mobile)
    if (strip.scrollWidth > strip.clientWidth + 2) {
      const aL = active.offsetLeft, aR = aL + active.offsetWidth;
      const vL = strip.scrollLeft, vR = vL + strip.clientWidth;
      if (aL < vL) strip.scrollTo({ left: Math.max(0, aL - 14), behavior: 'smooth' });
      else if (aR > vR) strip.scrollTo({ left: aR - strip.clientWidth + 14, behavior: 'smooth' });
    }
    // vertical scroller (rare desktop overflow)
    else if (strip.scrollHeight > strip.clientHeight + 2) {
      const aT = active.offsetTop, aB = aT + active.offsetHeight;
      const vT = strip.scrollTop, vB = vT + strip.clientHeight;
      if (aT < vT) strip.scrollTo({ top: Math.max(0, aT - 14), behavior: 'smooth' });
      else if (aB > vB) strip.scrollTo({ top: aB - strip.clientHeight + 14, behavior: 'smooth' });
    }
  }
  function goToSlide(i) {
    if (!track || !slides.length) return;
    const idx = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    setActive(idx);
  }

  thumbs.forEach((t, i) => t.addEventListener('click', () => goToSlide(i)));
  const gp = $('#galPrev'), gn = $('#galNext');
  if (gp) gp.addEventListener('click', () => goToSlide(galIdx - 1));
  if (gn) gn.addEventListener('click', () => goToSlide(galIdx + 1));

  // keep active thumb in sync while the user drags/swipes the track
  if (track) {
    let st;
    track.addEventListener('scroll', () => {
      clearTimeout(st);
      st = setTimeout(() => {
        const w = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / w));
      }, 90);
    }, { passive: true });
  }

  /* ---------- init ---------- */
  // default to the first (2-month, lowest-price) tier so the lowest price shows on load; honor ?bundle=N (1-based) if present
  const wantIdx = +(new URLSearchParams(location.search).get('bundle'));
  const def = (wantIdx && bundles[wantIdx - 1]) || bundles[0];
  selectBundle(def);
  applyMode();
  paint();
})();
